import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/button';
import _ from 'lodash';
import { FaAngleRight, FaCheck } from 'react-icons/fa';

import Header from '../../components/partials/Header';
import VideoStart from './videoStart';
import { RegionContext } from '../../contexts/regionContext';
import { getUserID, getRegions, getRegionData, getWeekDays } from '../../service';
import InputSelect from '../../components/common/InputSelect';
import ReuploadVideo from './reuploadVideo';
import { toast } from 'react-toastify';

export default function RegionVideosMenu() {
  const navigate = useNavigate();
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState({});
  const [activeDay, setActiveDay] = useState(1);
  const [isStart, setIsStart] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [regionData, setRegionData] = useContext(RegionContext);
  const [isVideoAvailable, setVideoAvailable] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [isReupload, setIsReupload] = useState(false);
  const [reuploadData, setReuploadData] = useState({});
  const [availableData, setAvailableData] = useState({});

  useEffect(() => {
    getDaysData();
    getPageData();
  }, []);

  useEffect(() => {
    if (regions.length < 1) return;

    const localSelectedRegion = localStorage.getItem('selectedRegion');

    if (localSelectedRegion) {
      const currentRegion = regions.find((item) => item.value === localSelectedRegion);
      if (currentRegion) {
        regionHandler(currentRegion);
      }
    }
  }, [regions]);

  const getDataByRegionId = async (regionId) => {
    const data = await getRegionData({
      regionId: regionId,
      masterOrganization: '650bd89479ba3ae92524955b'
    });
    const responseData = data.data.videoData;
    setAvailableData(responseData[0]);
    let uploadedVideos = [];
    responseData.map((regionItems) => {
      regionItems.days.map((day) => {
        day.videos.map((item) => {
          uploadedVideos.push(+item.videoID);
        });
      });
    });
    setVideoAvailable(uploadedVideos);
  };

  const getDaysData = async () => {
    try {
      const { data: weekDays } = await getWeekDays();
      let vId = 1;
      const updatedWeekDays = weekDays.data.map((item, key) => {
        const newItem = { ...item };
        newItem['videos'] = [];
        for (let i = 1; i <= 3; i++) {
          let videoData = {
            id: vId,
            label: `Vidéo ${i}`,
            value: `video-${vId}`
          };
          newItem['videos'].push(videoData);
          vId++;
        }
        return newItem;
      });
      await setMenuData(updatedWeekDays);
    } catch (e) {
      console.log(e);
    }
  };

  const getPageData = async () => {
    try {
      const { data: regionData } = await getRegions();
      const filteredRegions = regionData.map(({ name_fr, _id }) => ({
        value: _id,
        label: name_fr
      }));
      setRegions(filteredRegions);
    } catch (e) {
      console.log(e);
    }
  };

  const handleOption = (value) => {
    setActiveDay(value);
  };
  const handleClickVideo = (dayId, id, videoId, index) => {
    setSelectedData({ dayId: dayId, id: id, videoId: videoId });
    setRegionData({
      ...regionData,
      dayId: dayId,
      vidIndex: index + 1,
      regionId: selectedRegion.value
    });
    setIsStart(true);
  };

  const handleReuploadVideo = async (dayId, id, videoId, regiondata, vidId) => {
    try {
      setSelectedData({ dayId: dayId, id: id, videoId: videoId });
      setRegionData({
        ...regionData,
        eventDayId: dayId,
        vidIndex: vidId + 1,
        regionId: selectedRegion.value
      });
      let selecetedData = {};
      for (const items of availableData.days) {
        if (items.eventDayId === dayId) {
          for (const vidItems of items.videos) {
            if (vidItems.videoID === `${id}`) {
              selecetedData = vidItems;
              selecetedData['eventDayId'] = regiondata?._id ? regiondata?._id : '';
              selecetedData['dayName'] = regiondata.label ? regiondata.label : '';
              selecetedData['videoId'] = vidId + 1 || '';
            }
          }
        }
      }
      if (selecetedData) {
        setReuploadData(selecetedData);
        setIsReupload(true);
      }
    } catch (e) {
      console.log('error', e);
      toast(`quelque chose s'est mal passé`);
    }
  };

  const nextHandler = () => {
    if (menuData) {
      for (const items of menuData) {
        for (const [key, itm] of items.videos.entries()) {
          if (!isVideoAvailable.includes(itm.id)) {
            handleClickVideo(items._id, itm.id, itm.value, key);
            return;
          }
        }
      }
    }
  };

  const validHandler = () => {
    setIsStart(false);
    setIsReupload(false);
    navigate(`/region/video/${selectedData.id}/${selectedData.videoId}`);
  };

  const regionHandler = async (val) => {
    await setSelectedRegion(val);
    await getDataByRegionId(val.value);
  };

  const onLogout = async () => {
    localStorage.removeItem('regionToken');
    navigate('/region/login');
  };

  const onContinueHandle = async () => {
    setIsReupload(false);
    navigate(`/region/video/${selectedData.id}/${selectedData.videoId}`);
  };

  const onCloseReupload = () => {
    setIsStart(false);
    setIsReupload(false);
  };

  return (
    <>
      <Header type="title" title="LE BLOG VIDÉO" />
      {!isStart && !isReupload && (
        <div className="mx-4 overflow-auto h-screen mb-10 mt-20">
          <div className="my-10 px-5">
            <h2 className="text-2xl font-bold text-cblue-500">Le blog vidéo</h2>
            <p className="text-lg quickSand">
              Choisissez votre région et cliquez ensuite sur le jour & le numéro de la vidéo que
              vous voulez regarder ou enregistrer ou télécharger ou échanger :
            </p>
          </div>
          <div className="pb-5 px-4">
            {/* Region */}
            <InputSelect
              label="Région"
              labelClassName="font-bold quickSand w-3/4"
              placeholder="Région"
              className="my-1"
              name="region"
              value={selectedRegion}
              options={regions}
              onChange={(val) => {
                localStorage.setItem('selectedRegion', val.value);
                regionHandler(val);
              }}
            />
          </div>
          {selectedRegion?.value && (
            <div className="mx-3 py-2">
              {menuData.length > 0 && (
                <div className="space-y-6">
                  {menuData.map((day, key1) => (
                    <div key={key1}>
                      {/* Day label */}
                      <div className="font-bold text-xl mb-2 text-cblue-500 capitalize">
                        {day.label}
                        {' - '}
                        {new Date(day.date).toLocaleDateString('fr-FR', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </div>
                      {/* Videos for this day - horizontally scrollable */}
                      <div className="flex gap-3 overflow-x-auto pb-1 px-2">
                        {day.videos.map((itm, key2) => {
                          const uploaded = isVideoAvailable.includes(itm.id);
                          return (
                            <div
                              key={key2}
                              onClick={() => {
                                if (uploaded) {
                                  handleReuploadVideo(day?._id, itm.id, itm.value, day, key2);
                                } else {
                                  handleClickVideo(day?._id, itm.id, itm.value, key2);
                                }
                              }}
                              className={`relative min-w-[150px] w-[170px] h-[150px] rounded-xl border cursor-pointer ${
                                uploaded ? 'bg-cgold-500/40' : 'bg-cwhite-500'
                              }`}>
                              {/* dotted circle */}
                              {uploaded ? (
                                <div className="absolute top-2 left-2 w-6 h-6 rounded-full border-2 border-cblue-500 bg-cblue-500 flex items-center justify-center">
                                  <FaCheck className="text-white text-xs" />
                                </div>
                              ) : (
                                <div className="absolute top-2 left-2 w-6 h-6 rounded-full border-2 border-dashed border-gray-400" />
                              )}
                              {/* text */}
                              <div className="pt-10 px-2 pr-12">
                                <div className="font-semibold text-black leading-5">
                                  {itm.label}
                                </div>
                              </div>
                              {/* arrow button */}
                              <div className="absolute bottom-2 right-2 w-8 h-8 rounded-full bg-cblue-500 text-white flex items-center justify-center">
                                <FaAngleRight />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div className="mb-10">
            {isVideoAvailable.length !== 21 && (
              <div className="text-center mt-10">
                <Button.ButtonNext
                  title="Continuer"
                  disabled={!selectedRegion?.value}
                  handler={() => {
                    nextHandler();
                  }}
                  className="mx-auto"></Button.ButtonNext>
              </div>
            )}
          </div>
          <div className="mb-6 max-w-lg">
            <p className="mb-3 mx-3 quickSand">
              Si vous avez des questions ou besoin de support technique, adressez-vous à Jérémy
              Boiteux :
            </p>
            <p>
              <a href="tel:0608541528" className="underline font-bold">
                Portable : 0608541528
              </a>
              <br />
              <a href="mailto:jboiteux@cofom.org" className="underline font-bold">
                E-mail : jboiteux@cofom.org
              </a>
            </p>
          </div>
          <div className="mb-6">
            <button
              onClick={() => {
                onLogout();
              }}
              className="font-bold underline text-lg">
              DÉCONNECTER
            </button>
          </div>
        </div>
      )}
      {isStart && (
        <div className="absolute inset-0 mt-20" id="start-video">
          <div className="bg-white h-screen w-screen">
            <VideoStart startHandler={validHandler} />
          </div>
        </div>
      )}
      {isReupload && (
        <div className="absolute inset-0 mt-20" id="reupload-video">
          <div className="bg-white h-screen w-screen">
            <ReuploadVideo
              reuploadData={reuploadData}
              onContinueHandle={onContinueHandle}
              onCloseReupload={onCloseReupload}
            />
          </div>
        </div>
      )}
    </>
  );
}
